import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4276272091 from "../../../../../packages/component/src/components/checkbox/demo/demo1.js?loadDemo";
import legacyImportDemo_309513240 from "../../../../../packages/component/src/components/checkbox/demo/demo2.js?loadDemo";
import legacyImportDemo_3114681561 from "../../../../../packages/component/src/components/checkbox/demo/demo3.js?loadDemo";
import legacyImportDemo_1477606174 from "../../../../../packages/component/src/components/checkbox/demo/demo4.js?loadDemo";
import legacyImportDemo_1880255455 from "../../../../../packages/component/src/components/checkbox/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4276272091,
  legacyImportDemo_309513240,
  legacyImportDemo_3114681561,
  legacyImportDemo_1477606174,
  legacyImportDemo_1880255455,
  React
};